import { useEffect } from "react";

const SITE = "https://centrodiparodontologia.com";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  const prev = el.getAttribute("content");
  el.setAttribute("content", value);
  return () => el.setAttribute("content", prev || "");
};

export const useSeo = ({ title, description, path, jsonLd, image, type = "website" }) => {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    const url = `${SITE}${path}`;
    const restores = [
      setMeta("name", "description", description),
      setMeta("property", "og:title", title),
      setMeta("property", "og:description", description),
      setMeta("property", "og:url", url),
      setMeta("property", "og:type", type),
      setMeta("name", "twitter:title", title),
      setMeta("name", "twitter:description", description),
      ...(image ? [setMeta("property", "og:image", image), setMeta("name", "twitter:image", image)] : []),
    ];
    const canonical = document.head.querySelector('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute("href");
    canonical?.setAttribute("href", url);
    let script;
    if (ld) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = ld;
      document.head.appendChild(script);
    }
    return () => {
      document.title = prevTitle;
      restores.forEach((r) => r());
      if (prevCanonical) canonical.setAttribute("href", prevCanonical);
      script?.remove();
    };
  }, [title, description, path, ld, image, type]);
};
